import { gql } from '@apollo/client';
import UPDATE_STUDENT_SETTING_FRAGMENT from '../../fragments/update-student-setting-fragment';

const UPDATE_KEY_STUDENT_ONE_HANDED_TYPING_HAND_SETTING = gql`
  mutation updateKeyStudentSettingOneHandedTypingHand(
    $data: [UpdateKeyStudentSettingOneHandedTypingHandInput!]!
  ) {
    updateKeyStudentSettingOneHandedTypingHand(data: $data) {
      ...UpdateStudentSettingFragment
    }
  }
  ${UPDATE_STUDENT_SETTING_FRAGMENT}
`;

export default UPDATE_KEY_STUDENT_ONE_HANDED_TYPING_HAND_SETTING;
